// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import * as React from "react";

const IconSignup: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd" transform="translate(1 1)">
                <circle cx="15" cy="15" r="15" fill="#E7EBEF" stroke="currentColor" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M6.125,7 C8.05820346,7 9.625,5.43292975 9.625,3.5 C9.625,1.56707025 8.05820346,0 6.125,0 C4.19179696,0 2.625,1.56707025 2.625,3.5 C2.625,5.43292975 4.19179696,7 6.125,7 Z M7.51132846,8.3125 L4.73867196,8.3125 C2.12214845,8.3125 0,10.4343752 0,13.0511715 C0,13.5745313 0.424375117,13.9991801 0.947734475,13.9991801 L11.3028129,13.9991801 C11.8261719,14 12.25,13.5761719 12.25,13.0511715 C12.25,10.4343752 10.1281248,8.3125 7.51132846,8.3125 Z"
                    transform="translate(8.875 7.75)"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconSignup);
